import { removeCookie } from 'react-simple-cookie-store';
import { AccessToken } from './AccessToken';
export var clearCredentials = function () {
    removeCookie(AccessToken.Access);
    removeCookie(AccessToken.Refresh);
    removeCookie(AccessToken.Temporary);
};
